import React from 'react'
import styled from 'styled-components'
import { TABLET, DESKTOP } from '@streamr/streamr-layout/styled'

const UnstyledMemberListTitle = ({ className, children }) => (
    <div className={className}>
        <div>
            <p>Streamr</p>
            <h2>{children}</h2>
        </div>
    </div>
)

const MemberListTitle = styled(UnstyledMemberListTitle)`
    box-sizing: border-box;
    color: #0C009A;
    font-size: 16px;
    line-height: 2em;
    margin: 0 auto 2em;
    padding: 0 4rem;
    pointer-events: none;
    position: relative;
    z-index: 2;
    
    > div {
        margin: 0 auto;
        max-width: 533px;
    }
    
    p,
    h2 {
        margin: 0;
    }
    
    p {
        font-size: 1em;
    }
    
    h2 {
        font-size: 1.75em;
        font-weight: normal;
        line-height: 2rem;
        margin-top: 0.25rem;
        text-align: left;
        width: 0;
        white-space: nowrap;
    }

    @media (min-width: ${TABLET}px) {
        left: 4em;
        margin: 0;
        position: absolute;
        top: 0;

        > div {
            margin: 0;
            max-width: none;
        }

        p {
            font-size: 1.125rem;
        }

        h2 {
            font-size: 2rem;
            line-height: 2.5rem;
        }
    }
    
    @media (min-width: ${DESKTOP}px) {
        left: 6em;
        
        p {
            font-size: 1.25em;
        }

        h2 {
            font-size: 2.5em;
            line-height: 3rem;
        }
    }
`

export default MemberListTitle
